import { ModalFooterButton } from '@/components/Modal'
import { useTexts } from '../../../useTexts'
import { useController } from '../../../hooks/useController'

export function ButtonExportOrdersAndApplyChanges() {
  const texts = useTexts()
  const {
    updateData,
    data: { inputError },
  } = useController()

  return (
    <ModalFooterButton
      testid="modal-primary-button"
      title={texts.buttonExportOrdersAndApplyChanges}
      variant="contained"
      onClick={() => updateData({ model: 'export' })}
      disabled={!!inputError.hasError}
    >
      {texts.buttonExportOrdersAndApplyChanges}
    </ModalFooterButton>
  )
}
